export default __webpack_public_path__ + "static/media/reginaSpektor.496295dc.jpeg";